import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/content";

const categoryLinks = [
  { label: "剧情介绍", path: `/category/${encodeURIComponent("剧情介绍")}` },
  { label: "演员资料", path: `/category/${encodeURIComponent("演员资料")}` },
  { label: "影视资讯", path: `/category/${encodeURIComponent("影视资讯")}` },
];

const siteLinks = [
  { label: "首页", path: "/" },
  { label: "站内搜索", path: "/search" },
  { label: "关于我们", path: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full max-w-[1280px] gap-10 px-4 py-12 md:grid-cols-2 md:px-6 md:py-16 lg:grid-cols-[1.4fr_1fr_1fr_1.1fr] lg:px-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-base font-bold text-foreground-950">
              嫂
            </span>
            <div>
              <p className="font-heading text-lg font-bold text-background-50">嫂子的诱惑</p>
              <p className="mt-1 text-[10px] uppercase tracking-[0.28em] text-background-100/50">
                The Temptation · 影视内容站
              </p>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-100/70">
            一个专注《嫂子的诱惑》的剧集资料站，整理剧情章节、演员档案与幕后资讯，陪你把每一集看得更明白。
          </p>
          <p className="mt-4 text-xs text-background-100/40">
            本站为影视内容介绍与资讯整理站点，不提供任何音视频播放服务。
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold text-accent-300">内容分类</h3>
          <ul className="mt-4 space-y-3">
            {categoryLinks.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className="text-sm text-background-100/70 transition-colors hover:text-accent-300"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold text-accent-300">站内导航</h3>
          <ul className="mt-4 space-y-3">
            {siteLinks.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className="text-sm text-background-100/70 transition-colors hover:text-accent-300"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold text-accent-300">联系我们</h3>
          <ul className="mt-4 space-y-3 text-sm text-background-100/70">
            <li className="flex items-start gap-2">
              <i className="ri-mail-line mt-0.5 text-base text-accent-400" />
              <span>{siteInfo.contact.email}</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-time-line mt-0.5 text-base text-accent-400" />
              <span>{siteInfo.contact.workTime}</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line mt-0.5 text-base text-accent-400" />
              <span>{siteInfo.contact.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-3 px-4 py-6 text-xs text-background-100/45 sm:flex-row sm:items-center sm:justify-between md:px-6 lg:px-10">
          <p>© 2026 嫂子的诱惑 · 内容仅为剧集介绍与资讯整理，版权归原制作方所有。</p>
          <p className="text-background-100/35">
            本站演示数据用于内容浏览与搜索展示，在线观看功能敬请期待。
          </p>
        </div>
      </div>
    </footer>
  );
}